"use client"

import clsx from "clsx"

import { useLocale } from "~/lib/i18n/hooks/useLocale"
import { getI18nKey } from "~/lib/i18n/utils/get-i18n"
import serializeDeliveryEstimationsDate from "~/components/ui/Product/ProductHeader/_data/serialize-delivery-estimations-date"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import { sprinkles } from "~/styles/sprinkles.css"
import { text } from "~/styles/variants"

export function DeliveryEstimations() {
  const locale = useLocale()
  const t = useTranslate()

  const deliveryEstimations = serializeDeliveryEstimationsDate(new Date())

  const currentDate = new Date().getUTCDay()
  const deliveryEstimationDay = deliveryEstimations.getUTCDay()

  return (
    <div
      className={clsx(
        sprinkles({ display: "flex", justifyContent: "center" }),
        text({
          design: "riposte-13",
          color: "blue-light-txt",
        })
      )}
    >
      {currentDate === deliveryEstimationDay
        ? t("product_delivery_estimations_today")
        : t("product_delivery_estimations", {
            date: new Intl.DateTimeFormat(getI18nKey(locale, "intl"), {
              weekday: "long",
              day: "numeric",
              month: "numeric",
            }).format(deliveryEstimations),
          })}
    </div>
  )
}
